import App from '../client/containers/App';
import React from 'react';
import makeAppCenterRoutes from '../server/lib/makeAppCenterRoutes';
import { tabRouteNames, PARTNERS } from '../client/lib/constants';
import NotFound from '../client/components/NotFound';
import AppError from '../client/components/AppError';
import loadable from '@loadable/component';

const MyApps = loadable(() =>
  import(/* webpackChunkName: "MyApps" */ '../client/containers/MyApps')
);
const AppCenter = loadable(() =>
  import(/* webpackChunkName: "AppCenter" */ '../client/containers/AppCenter')
);
const AppDetailPage = loadable(() =>
  import(
    /* webpackChunkName: "AppDetailPage" */ '../client/containers/AppDetailPage'
  )
);
const ProductBundle = loadable(() =>
  import(
    /* webpackChunkName: "ProductBundle" */ '../client/containers/covid/ProductBundle'
  )
);
const Quiz = loadable(() =>
  import(/* webpackChunkName: "Quiz" */ '../client/containers/Quiz')
);
const OtssConnect = loadable(() =>
  import(
    /* webpackChunkName: "OtssConnect" */ '../client/containers/OtssConnect'
  )
);

export default function(appCenterSchema) {
  return [
    {
      path: '/',
      component: App,
      routes: []
        .concat(
          tabRouteNames.map(route => ({
            path: route,
            component: MyApps,
            exact: true
          }))
        )
        .concat(
          PARTNERS.map(partner => ({
            exact: true,
            path: `sell/${partner}`,
            render: props => <AppDetailPage partner={partner} {...props} />
          }))
        )
        .concat(makeAppCenterRoutes(appCenterSchema, AppCenter))
        .concat({
          path: 'appcenter',
          component: AppCenter,
          exact: true
        })
        .concat({
          path: 'setup-recommendations',
          component: Quiz,
          exact: true
        })
        .concat({
          path: 'walmart-connect',
          component: OtssConnect,
          exact: true
        })
        .concat({
          path: 'error',
          component: AppError,
          exact: true
        })
        .concat({
          path: 'product-bundle',
          component: ProductBundle
        })
        .map(route => {
          route.path = '/' + route.path;
          return route;
        })
        .concat({
          path: '*',
          component: NotFound
        })
    }
  ];
}
